export default __webpack_public_path__ + "static/media/content_copy.79fbce0b.svg";